import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function VeteranOwned() {
  return <section id="about" className="py-24 bg-background relative overflow-hidden" data-id="element-202">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" data-id="element-203" />
      <div className="absolute -right-40 -top-40 w-96 h-96 bg-primary/5 rounded-full blur-3xl" data-id="element-204" />

      <div className="container mx-auto px-4" data-id="element-205">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-206">
          <div className="w-full lg:w-1/2 relative" data-id="element-207">
            <div className="aspect-square md:aspect-[4/3] rounded-lg overflow-hidden border border-border relative z-10" data-id="element-208">
              <img src="https://cdn.magicpatterns.com/uploads/gDGgzzzxJHK4TYKrrrPF6B/619895998_122120023977009454_1086733934003049031_n.jpg" alt="Drop Zone Cleanup Co. branded dumpster loaded with construction debris" className="w-full h-full object-cover hover:scale-105 transition-all duration-700" data-id="element-209" />
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply" data-id="element-210" />
            </div>
            {/* Tactical accent box */}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-secondary border border-border -z-10 rounded-lg hidden md:block" data-id="element-211" />
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 -z-10 rounded-lg hidden md:block" data-id="element-212" />
          </div>

          <div className="w-full lg:w-1/2" data-id="element-213">
            <h2 className="text-primary font-bold tracking-widest uppercase text-sm mb-3 flex items-center gap-2" data-id="element-214">
              <span className="w-8 h-[2px] bg-primary" data-id="element-215"></span>
              Our Background
            </h2>
            <h3 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight mb-6" data-id="element-216">
              Veteran Owned. <br data-id="element-217" />
              Mission Driven.
            </h3>

            <p className="text-muted-foreground text-lg mb-8 leading-relaxed" data-id="element-218">
              At Drop Zone Cleanup Co., we don't just haul junk—we execute
              missions. Founded by veterans, we bring the same discipline,
              integrity, and work ethic from our military service to your
              property. When you call us, you're getting a team that shows up on
              time, works hard, and gets the job done right.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-219">
              {['Military precision and discipline on every job site', 'Straightforward, transparent pricing with no hidden fees', 'Fully licensed and insured for your peace of mind', 'Eco-friendly disposal and recycling whenever possible'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-220">
                  <CheckCircle2 className="w-6 h-6 text-primary shrink-0" data-id="element-221" />
                  <span className="text-foreground font-medium" data-id="element-222">{item}</span>
                </li>)}
            </ul>

            <div className="p-6 bg-card border border-border rounded-lg inline-block" data-id="element-223">
              <p className="font-heading font-bold text-xl uppercase tracking-wider text-foreground" data-id="element-224">
                "Discipline equals clean sites."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}